import type { Languages } from '@snowit/system/useLanguage/constants';

import useLanguage from '@snowit/system/useLanguage';

export default () => {
  const { changeLanguage } = useLanguage();
  return {
    language: (lng: string) => {
      if (lng === 'dev') {
        changeLanguage('cimode' as Languages);
        return;
      }
      changeLanguage(lng as Languages);
    },
  };
};
